import AppBlockWrapper from './AppBlockWrapper.vue';

export default AppBlockWrapper;



// WEBPACK FOOTER //
// ./src/uikit/components/AppBlockWrapper/index.ts